























import Vue, { PropType } from 'vue';
import { CreationProcess } from '@/store/getStarted';
export default Vue.extend({
  props: {
    creationProcess: {
      type: Object as PropType<CreationProcess>,
      required: true
    }
  }
});
